import { useCallback, useMemo } from "react";
import { envChangeType } from "../../plugins/utils";

export const useGtm = () => {
  const isHaveGCode = useMemo(() => {
    const gcode = envChangeType("REACT_APP_GCODE");
    return gcode !== "" && gcode != null && gcode !== undefined;
  }, []);

  const pushEvent = useCallback(
    ({ eventName, properties = {} }) => {
      if (!isHaveGCode) return;
      if (typeof window !== "undefined") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: eventName,
          eventProps: properties,
        });
      }
    },
    [isHaveGCode],
  );

  return {
    isHaveGCode,
    pushEvent,
  };
};
